import React from 'react';
import { connect } from 'react-redux';
import server from '../api/server';

import Nav from './Nav';
import { Helmet } from "react-helmet";
import { fetchForm, fetchRequestedInfo, fetchTaskStatus } from '../actions';

import { Link } from "react-router-dom";
import firebase from './Firebase.js';
import history from '../history';
import ConsentPage from './consent/ConsentPage';

const ICON_BRIEFCASE = (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M7 3a2 2 0 00-2 2v1H4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-1V5a2 2 0 00-2-2H7zm0 3h6V5H7v1z"
      clipRule="evenodd"
    />
  </svg>
);

const ICON_SHIELD = (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M10 1.5 3.5 4v5.5C3.5 13.5 6.4 17.2 10 18.5c3.6-1.3 6.5-5 6.5-9V4L10 1.5z"
      clipRule="evenodd"
    />
  </svg>
);

const ICON_UPLOAD = (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path d="M10 2a1 1 0 01.7.3l4 4a1 1 0 01-1.4 1.4L11 5.4V13a1 1 0 11-2 0V5.4L6.7 7.7A1 1 0 015.3 6.3l4-4A1 1 0 0110 2zM4 14a1 1 0 011 1v1h10v-1a1 1 0 112 0v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1z" />
  </svg>
);

const ICON_BANK = (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path d="M10 1 1 5v2h18V5l-9-4zM3 8v7H1v2h18v-2h-2V8h-2v7h-2V8h-2v7H8V8H6v7H4V8H3z" />
  </svg>
);

const ICON_CHEVRON = (
  <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M7.3 4.3a1 1 0 011.4 0l5 5a1 1 0 010 1.4l-5 5a1 1 0 01-1.4-1.4L11.6 10 7.3 5.7a1 1 0 010-1.4z"
      clipRule="evenodd"
    />
  </svg>
);

const ICON_CHECK = (
  <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M16.7 5.3a1 1 0 010 1.4l-7.4 7.4a1 1 0 01-1.4 0L3.3 9.5a1 1 0 011.4-1.4l3.9 3.9 6.7-6.7a1 1 0 011.4 0z"
      clipRule="evenodd"
    />
  </svg>
);

class Dashboard extends React.Component {
  componentDidMount() {
    this.checkAuth();
  }

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      loggedIn: false,
      consentStatus: null,
      showConsentModal: false,
      checkingConsent: true
    };
  }

  checkAuth = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log('logged in.');
        this.setState({ loggedIn: true });
        this.props.fetchForm(this.props.match.params.id);
        this.props.fetchRequestedInfo(this.props.match.params.id);
        this.props.fetchTaskStatus(this.props.match.params.id);
        this.fetchName();
        this.checkConsentStatus();
        // User is signed in.
      } else {
        history.push("/client");
        // No user is signed in.
      }
    });
  };

  componentDidUpdate = () => {
  };

  fetchName = async () => {
    const response = await server.post("/name", { application_id: this.props.match.params.id });
    if (response.data != false) {
      this.setState({ name: response.data });
    } else {
      this.setState({ name: " " });
    }
  };

  checkConsentStatus = async () => {
    try {
      const response = await server.post("/consent/check");
      const consentStatus = response.data;
      
      this.setState({ 
        consentStatus: consentStatus,
        showConsentModal: consentStatus.needs_consent,
        checkingConsent: false
      });
    } catch (error) {
      console.error("Error checking consent status:", error);
      this.setState({ 
        checkingConsent: false,
        showConsentModal: true // Show modal on error to be safe
      });
    }
  };

  handleConsentSubmitted = () => {
    // Consent was successfully submitted, refresh status and close modal
    this.setState({ showConsentModal: false });
    this.checkConsentStatus();
  };

  // Build a properly formatted greeting from the application's applicants,
  // e.g. "John", "John & Jane", "John, Jane & Bob", "John, Jane, Bob & Alice".
  formatApplicantNames = () => {
    const applicants = this.props.applicants || {};
    const names = Object.keys(applicants)
      .map((k) => (applicants[k] && applicants[k].name) || '')
      .map((n) => String(n).trim())
      .filter((n) => n.length > 0);

    if (names.length === 0) return null;
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} & ${names[1]}`;
    const head = names.slice(0, -1).join(', ');
    const tail = names[names.length - 1];
    return `${head} & ${tail}`;
  };

  buildTasks = () => {
    const r = this.props.requested_info || {};
    const status = this.props.task_status || {};
    const id = this.props.id;
    // The redesigned fact find lives at /fact-find/:applicationId. We opt
    // in per-application via `fact_find_version` returned by
    // /api/requestedInfo (set to 2 on every newly-created application).
    const isFactFindV2 = r.fact_find_version === 2;
    const all = [
      {
        key: 'fact_find',
        visible: r.fact_find == true,
        icon: ICON_BRIEFCASE,
        title: 'Fact Find Form',
        description:
          'Help us understand your circumstances.',
        to: isFactFindV2 ? `/fact-find/${id}` : `/factfindform/${id}`,
      },
      {
        key: 'id',
        visible: r.id == true,
        icon: ICON_SHIELD,
        title: 'Verification of Identity',
        description: 'Verify your identity to process your application.',
        to: `/identification/${id}`,
      },
      {
        key: 'docs',
        visible: r.docs == true,
        icon: ICON_UPLOAD,
        title: 'File Upload',
        description: 'Upload the supporting documents we need.',
        to: `/upload/${id}`,
      },
      {
        key: 'bankstatements',
        visible: r.bankstatements == true,
        icon: ICON_BANK,
        title: 'Bank Statements',
        description: 'Securely share your bank statements.',
        to: `/bankstatements/${id}`,
      },
    ];
    return all
      .filter((t) => t.visible)
      .map((t) => ({ ...t, done: !!status[t.key] }));
  };

  renderTaskRow = (task) => {
    const isDone = task.done === true;
    return (
      <Link
        key={task.key}
        to={task.to}
        className="group flex items-center gap-4 rounded-2xl bg-white border border-[#E5E7EB] px-4 py-4 sm:px-5 sm:py-5 transition-all hover:border-[#C4B5FD] hover:shadow-sm"
      >
        <span className="relative flex-shrink-0">
          <span
            className="inline-flex items-center justify-center h-11 w-11 rounded-xl"
            style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
          >
            {task.icon}
          </span>
          {isDone ? (
            <span
              className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center h-4 w-4 rounded-full ring-2 ring-white text-white"
              style={{ backgroundColor: '#10B981' }}
              aria-label="Completed"
            >
              {ICON_CHECK}
            </span>
          ) : (
            <span
              className="absolute -top-0.5 -right-0.5 inline-block h-3 w-3 rounded-full ring-2 ring-white"
              style={{ backgroundColor: '#F59E0B' }}
              aria-label="Not yet completed"
            />
          )}
        </span>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="text-base font-bold text-[#1F2937] leading-tight">
              {task.title}
            </h3>
            {isDone ? (
              <span
                className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
                style={{ backgroundColor: '#D1FAE5', color: '#065F46' }}
              >
                <span
                  className="inline-block h-1 w-1 rounded-full"
                  style={{ backgroundColor: '#10B981' }}
                />
                Done
              </span>
            ) : (
              <span
                className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
                style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}
              >
                <span
                  className="inline-block h-1 w-1 rounded-full"
                  style={{ backgroundColor: '#F59E0B' }}
                />
                To do
              </span>
            )}
          </div>
          <p className="mt-0.5 text-sm text-[#6B7280] leading-snug truncate">
            {task.description}
          </p>
        </div>
        <span
          className="flex-shrink-0 transition-colors"
          style={{ color: '#9CA0AE' }}
        >
          {ICON_CHEVRON}
        </span>
      </Link>
    );
  };

  renderEmptyState = () => {
    return (
      <div className="rounded-2xl bg-white border border-dashed border-[#E5E7EB] px-5 py-10 text-center">
        <p className="text-sm text-[#6B7280]">
          No tasks have been requested yet.
        </p>
      </div>
    );
  };

  renderLoader = () => {
    return (
      <div
        className="min-h-screen w-full flex flex-col items-center justify-center px-6"
        style={{ backgroundColor: '#F5F6FA' }}
      >
        <img
          src={process.env.PUBLIC_URL + '/images/logos/dark_transparent.png'}
          alt="LoanGateway"
          className="h-8 sm:h-10 w-auto mb-6"
        />
        <span
          className="inline-block h-6 w-6 rounded-full border-2 border-[#E5E7EB] animate-spin"
          style={{ borderTopColor: '#7C5CFC' }}
        />
      </div>
    );
  };

  renderDashboard = () => {
    if (this.props.id == 'no-form') {
      return ('No-form');
    } else if (this.props.id != null && this.state.name != "") {
      const formattedNames = this.formatApplicantNames();
      const greetingName =
        formattedNames ||
        (this.state.name && this.state.name.trim() ? this.state.name : 'there');
      const tasks = this.buildTasks();
      const remaining = tasks.filter((t) => !t.done).length;
      const allDone = tasks.length > 0 && remaining === 0;

      return (
        <div className="min-h-screen w-full" style={{ backgroundColor: '#F5F6FA' }}>
          <Nav />

          <main className="px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
            <div className="max-w-2xl mx-auto">
              <div className="flex items-center gap-2 flex-wrap">
                <p
                  className="text-xs sm:text-sm font-semibold tracking-wide uppercase"
                  style={{ color: '#5B3FE0' }}
                >
                  Welcome back
                </p>
                {remaining > 0 ? (
                  <span
                    className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide"
                    style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}
                  >
                    <span
                      className="inline-block h-1.5 w-1.5 rounded-full"
                      style={{ backgroundColor: '#F59E0B' }}
                    />
                    {remaining} to do
                  </span>
                ) : allDone ? (
                  <span
                    className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide"
                    style={{ backgroundColor: '#D1FAE5', color: '#065F46' }}
                  >
                    <span
                      className="inline-block h-1.5 w-1.5 rounded-full"
                      style={{ backgroundColor: '#10B981' }}
                    />
                    All done
                  </span>
                ) : null}
              </div>
              <h1 className="mt-2 text-2xl sm:text-3xl font-bold text-[#1F2937]">
                Hi, {greetingName}
              </h1>
              <p className="mt-2 text-sm sm:text-base text-[#6B7280] leading-relaxed">
                {tasks.length === 0
                  ? "You're all caught up. Nothing to do right now."
                  : remaining === 0
                  ? "You're all caught up. Everything's been submitted."
                  : remaining === 1
                  ? 'You have 1 task left to complete.'
                  : `You have ${remaining} tasks left to complete.`}
              </p>

              <div className="mt-8 sm:mt-10 space-y-3">
                {tasks.length === 0
                  ? this.renderEmptyState()
                  : tasks.map((t) => this.renderTaskRow(t))}
              </div>
            </div>
          </main>
        </div>
      );
    } else {
      return this.renderLoader();
    }
  };

  render() {
    const { loggedIn, showConsentModal, checkingConsent } = this.state;

    return (
      <div className="dashboard">
        <Helmet>
          {/*
            Toggle the modern-page body styles via <html className>. See
            client/src/index.css ".lg-modern-page" rules - they override
            the legacy /css/loader.css (which forces html/body to 100px),
            hide the full-screen .full-loader overlay, and set the modern
            background + font. Using <html> attributes (instead of an
            inline <style> tag) ensures react-helmet@6.1 correctly
            REMOVES them on unmount so they don't leak into /admin pages
            (which would otherwise lose Poppins font + Metronic's flex
            layout).
          */}
          <html className="lg-modern-page" />
          <title>LoanGateway - Mortgage Choice Sydney CBD</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>

        {/* Show loading while checking consent */}
        {checkingConsent && loggedIn && this.renderLoader()}

        {/* Show dashboard only if logged in and consent is valid */}
        {loggedIn && !checkingConsent && !showConsentModal ? this.renderDashboard() : null}

        {/* Full-page consent gate — shown before the dashboard when needed */}
        {showConsentModal && (
          <ConsentPage onConsentSubmitted={this.handleConsentSubmitted} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    id: state.id,
    requested_info: state.requested_info,
    applicants: state.applicants,
    task_status: state.task_status,
  };
};

export default connect(mapStateToProps, { fetchForm, fetchRequestedInfo, fetchTaskStatus })(Dashboard);
